// queries/useProjects.ts
import { API_ENDPOINTS } from '@/api/endpoints';
import { Project } from '@/stores/ProjectStore';
import { apiFetch } from '@/util/apiClient';
import { useQuery } from '@tanstack/react-query';

export function useGetProject(orgId?: string, projId?: string) {
  return useQuery({
    queryKey: ['project', orgId, projId],
    queryFn: async () => {
      if (!orgId || !projId) {
        // this error should never throw because the queryFn is only enabled when orgId
        // and subProjId is present
        throw new Error("ID's must be defined");
      }
      return apiFetch<Project>(
        API_ENDPOINTS.ORGANIZATIONS.PROJECTS.DETAIL(orgId, projId),
      );
    },
    enabled: !!orgId && !!projId,
  });
}
